import { combineReducers } from 'redux';
import campaignModalReducer from './modal_reducer';
import genericCampaignReducer
    from './generic_campaign_reducer';
import carouselReducer from './carousel_reducer';
import bannerReducer from './banner_reducer';
import storiesReducer from './stories_reducer';

// TODO(PEDRO): criar reducer para carousel e stories integrado com mesmas funcionalidades
const reducers = combineReducers({
    bannerStates: bannerReducer,
    campaignModalStates: campaignModalReducer,
    campaignStates: genericCampaignReducer,
    carouselStates: carouselReducer,
    storiesStates: storiesReducer,
});

export default reducers;
